import { TextPartHighlight } from '@components/Sections/Sections.styled';

import { MainText } from './MainText';
import { TitlePenOutline, TitlePenUnderline, IllustrationPens } from './Pens';
import {
  StyledContainer,
  MainTitle,
  FirstTitlePart,
  SecondTitlePartDesktop,
  SecondTitlePartTablet,
  SecondTitlePartMobile,
  ThirdTitlePartNotTablet,
  ThirdTitlePartTablet,
  TextBlock,
  Subtitle,
  Quote,
} from './SectionOne.styled';

export const SectionOne: React.FC = () => {
  return (
    <section>
      <StyledContainer>
        <MainTitle>1. How come there are so few women in esports?</MainTitle>

        <FirstTitlePart role="presentation" aria-hidden>
          How come
        </FirstTitlePart>

        <SecondTitlePartDesktop role="presentation" aria-hidden>
          there are{' '}
          <TextPartHighlight>
            so few
            <TitlePenOutline />
          </TextPartHighlight>{' '}
          women
        </SecondTitlePartDesktop>
        <SecondTitlePartTablet role="presentation" aria-hidden>
          there are{' '}
          <TextPartHighlight>
            so few
            <TitlePenOutline />
          </TextPartHighlight>
        </SecondTitlePartTablet>
        <SecondTitlePartMobile role="presentation" aria-hidden>
          there are <br /> so few{' '}
          <TextPartHighlight>
            women
            <TitlePenOutline />
          </TextPartHighlight>
        </SecondTitlePartMobile>

        <ThirdTitlePartNotTablet role="presentation" aria-hidden>
          in{' '}
          <TextPartHighlight>
            esports?
            <TitlePenUnderline />
          </TextPartHighlight>
        </ThirdTitlePartNotTablet>
        <ThirdTitlePartTablet role="presentation" aria-hidden>
          <TextPartHighlight>
            women in
            <TitlePenUnderline />
          </TextPartHighlight>{' '}
          esports?
        </ThirdTitlePartTablet>

        <TextBlock aside={<Subtitle>Setup</Subtitle>} text={<MainText />} />

        <Quote
          quote="There were lots of tournaments, everything was on the rise, but the girls were forgotten. There was nothing apart from the occasional Copenhagen Games and Katowice events. With two tournaments per year, what kind of motivation is it to have a roster for that? Any team requires a lot of money, and the salaries seem unjustified, just because of how women's teams are in a place like this. The interest in this (scene) has been on a decline, and now it's unclear how to develop, this is why we ended up where we are."
          author="Female, ex-professional player, 32 y.o. "
        />

        <IllustrationPens />
      </StyledContainer>
    </section>
  );
};
